<div class="modal-body  col-sm-12 form-group">
    @if (true) {
        <form [formGroup]="ExpenseForForm" (ngSubmit)="onExpenseFormSubmit(ExpenseForForm.value);">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="drpCaseNotice">Case/Notice <span style="color:red;">*</span> </label>
                                <ng-select [items]="CaseNoticeList" [multiple]="false" formControlName="drpCaseNotice" placeholder="Select Case/Notice" bindLabel="refno" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" >
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.refno}}&nbsp;&nbsp;&nbsp;({{item.type}})&nbsp;&nbsp;&nbsp;({{item.NoticeDt|date:'dd-MMM-yyyy'}})
                                    </ng-template>
                                </ng-select>
                                @if (f.drpCaseNotice.touched && f.drpCaseNotice.invalid) {
                                    @if (f.drpCaseNotice.errors?.required) {
                                        <div class="text-danger">Case/Notice is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Region">Region <span class="text-danger">*</span> </label>
                                <ng-select [items]="RegionData" bindLabel="MainDescr" bindValue="hdID" formControlName="Region" [clearable]="false" placeholder="Select Region">
                                    <ng-option [value]="'0'">Select Region</ng-option>
                                </ng-select>
                                @if (f.Region.touched && f.Region.invalid) {
                                    @if (f.Region.errors?.required) {
                                        <div class="text-danger">Region is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Branch">Branch <span class="text-danger">*</span> </label>
                                <ng-select [items]="BranchData" bindLabel="MainDescr" bindValue="hdID" formControlName="Branch" [clearable]="false" placeholder="Select Region">
                                    <ng-option [value]="'0'">Select Region</ng-option>
                                </ng-select>
                                @if (f.Branch.touched && f.Branch.invalid) {
                                    @if (f.Branch.errors?.required) {
                                        <div class="text-danger">Branch is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                              <label for="ExpenseCategory">Expense Category <span class="text-danger">*</span> </label>
                              <ng-select [items]="ExpenseCategory" bindLabel="SubDescr" bindValue="SubID" formControlName="ExpenseCategory" (change)="onCategorySelect($event)"  [clearable]="false" placeholder="Select Category">
                                <ng-option [value]="'0'">Select Category</ng-option>
                              </ng-select>  
                                @if (f.ExpenseCategory.touched && f.ExpenseCategory.invalid) {
                                    @if (f.ExpenseCategory.errors?.required) {
                                        <div class="text-danger">Expense Category is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="ExpenseSubCategory" class="form-label"><a href="{{RouteGMExpenseSubCategory}}" target="_blank">Expense Sub Category <span style="color:red;">*</span> </a></label>
                                <ng-select [items]="ExpenseSubCategoryData" bindLabel="MainDescr" bindValue="hdID" formControlName="ExpenseSubCategory" [clearable]="false" placeholder="Select subcategory">
                                    <ng-option [value]="'0'">Select subcategory</ng-option>
                                </ng-select>
                                @if (f.ExpenseSubCategory.touched && f.ExpenseSubCategory.invalid) {
                                    @if (f.ExpenseSubCategory.errors?.required) {
                                        <div class="text-danger">Expense Sub Category is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="NatureofExpense"><a href="{{RouteGMNatureOfExpense}}" target="_blank">Nature of Expense<span style="color:red;">*</span></a></label>
                                <ng-select [items]="ExpenseNatureData" bindLabel="MainDescr" bindValue="hdID" formControlName="NatureofExpense"  (change)="onNatureofExpenseChange($event)" [clearable]="false" placeholder="Select Nature of Expense">
                                    <ng-option [value]="'0'">Select Nature of Expense</ng-option>
                                </ng-select>
                                @if (f.NatureofExpense.touched && f.NatureofExpense.invalid) {
                                    @if (f.NatureofExpense.errors?.required) {
                                        <div class="text-danger">Nature of Expense is required.</div>
                                    }
                                }
                            </div>
                        </div>
                        @if(HideEmployee != '!isHidden'){
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="Employee">Employee</label>
                                    <ng-select [items]="EmployeeData" bindLabel="name" bindValue="id1" formControlName="Employee" [clearable]="false" placeholder="Select Employee">
                                        <ng-option [value]="'0'">Select Employee</ng-option>
                                    </ng-select>
                                    @if (f.Employee.touched && f.Employee.invalid) {
                                        @if (f.Employee.errors?.required) {
                                            <div class="text-danger">Employee is required.</div>
                                        }
                                    }
                                </div>
                            </div>
                        }
                        @if(HideLawyer != '!isHidden' ){
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="Lawyer">Lawyer</label>
                                    <ng-select [items]="LawyerData" bindLabel="Name" bindValue="ContactID" formControlName="Lawyer" [clearable]="false" placeholder="Select Lawyer">
                                        <ng-option [value]="'0'">Select Lawyer</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        }
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="ExpenseDate">Expense Date<span style="color:red;">*</span></label>
                                <mat-form-field class="fullwidth" appearance="outline">
                                    <input matInput  [min]="minDate" formControlName="ExpenseDate" [max]="maxDate" [matDatepicker]="pickerPlanupdate" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="pickerPlanupdate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPlanupdate></mat-datepicker>
                                </mat-form-field>
                                @if (f.ExpenseDate.touched && f.ExpenseDate.invalid) {
                                    @if (f.ExpenseDate.errors?.required) {
                                        <div class="text-danger">Expense Date is required.</div>
                                    }
                                }                           
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Description">Description<span style="color:red;">*</span></label>
                                <textarea class="form-control" formControlName="Description" rows="2" placeholder="Enter Description"></textarea>
                            </div>
                            @if (f.Description.touched && f.Description.invalid) {
                                @if (f.Description.errors?.required) {
                                    <div class="text-danger">Description is required.</div>
                                }
                            }
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Amount">Total Amount<span style="color:red;">*</span></label>
                                <input type="text" class="form-control" formControlName="UnitRate" [(ngModel)]="UnitRate4" placeholder="Enter Total Amount">
                                @if (f.UnitRate.touched && f.UnitRate.invalid) {
                                    @if (f.UnitRate.errors?.required) {
                                        <div class="text-danger">Total Amount is required.</div>
                                    }
                                }
                                @if (f.UnitRate.touched && f.UnitRate.value <= 0) {
                                    <div class="text-danger">Total Amount should be greater than 0.</div>
                                }
                            </div>
                        </div>
                        @if(HideCol != '!isHidden'){
                            <div class="col-12 col-md-6">
                                <label for="NoofUnit" class="form-label">No. Of Unit<span style="color:red;">*</span></label>
                                <input type="text" class="form-control" formControlName="NoofUnit" [(ngModel)]="NoofUnit4" placeholder="Enter Unit">
                            </div>
                            <div class="col-12 col-md-6">
                                <label for="TotalAmount" class="form-label">Total Amount<span style="color:red;">*</span></label>
                                <input type="text" class="form-control" [value]="UnitRate4*NoofUnit4" placeholder="Enter Total Amount">
                            </div>
                        }

                        @if (IsDisplayButton == '0' && expenseID > 0 ) {
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="Status">Status</label>
                                    <input type="text" class="form-control" readonly [value]="StatusType" placeholder="Enter Status">
                                </div>
                            </div>
                        }

                        <!-- @if (IsDisplayButton == '0' && expenseID > 0 && (Status == '1' || Status == '2')) {
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="ReasonExpense">Reason For Reject or Approve</label>
                                    <input type="text" class="form-control" readonly [value]="ReasonExpense" placeholder="Enter Reason For Reject or Approve">
                                </div>
                            </div>
                        }
                        @if (IsDisplayButton == '1') {
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="Reason">Reason For Reject or Approve</label>
                                    <input type="text" class="form-control" formControlName="Reason" placeholder="Enter Reason For Reject or Approve">
                                </div>
                            </div>
                        } -->

                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="UploadFile" class="form-label">Upload File</label>
                                <input type='file' (change)="onSelectFile($event)">
                                <br/>
                                <button *ngIf="this.expenseID>0" title="Upload File" class="btn  btn-primary btn-sm" type="submit" (click)="ExpenseFileUpload('')">
                                    Upload File&nbsp;<span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                        @if (FullyFileData?.length > 0){
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="UploadFile" class="form-label">Preview File</label>
                                    <div class="w-100">
                                        @for (mDtl of FullyFileData; track $index) {
                                            {{mDtl.FullyFileName}}<button type="button" class="btn btn-success btn-sm btn-round waves-effect waves-light m-2" id="PREVIEWFILE" (click)="GETPREVIEWFILE()"> <i class="fa fa-download" ></i> </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </div>
                @if (RightsID.includes('202026001') || 
                  RightsID.includes('202026021')) {
                  <div class="d-flex align-items-center justify-content-center mt-3" [hidden]="HideButtonSubmit" >
                    @if (IsDisplayButton == '0' || IsDisplayButton == '1') {
                        <button class="btn btn-primary submit-btn small" type="submit">
                          {{ButtonCaption}}
                        </button>
                    }
                    <button type="button" style="display:none;" class="btn btn-primary col-sm-3" (click)="Approve(ExpenseForForm.value); ">Approve</button>
                    <button type="button" style="display:none;" class="btn btn-primary col-sm-3" (click)="Reject(ExpenseForForm.value); ">Reject</button>


                  </div>
                  }
        </form>
    }@else {
<!--         
        <form #ExpenseFor="ngForm" [formGroup]="ExpenseForForm" (ngSubmit)="onExpenseFormSubmit(ExpenseFor.value);">
            <div class="col-sm-4 height-34">Case/Notice</div>
            <div class="col-sm-6">
                <ng-select [items]="CaseNoticeList" [multiple]="false" formControlName="drpCaseNotice" bindLabel="refno" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="SelectedCaseNotice">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.refno}}&nbsp;&nbsp;&nbsp;({{item.type}})&nbsp;&nbsp;&nbsp;({{item.NoticeDt|date:'dd-MMM-yyyy'}})
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-4 height-34"><a href="{{RouteGMRegion}}" target="_blank">Region <span style="color:red;">*</span></a></div>
            <div class="col-sm-6">
              <ng-select
                [items]="RegionData"
                bindLabel="MainDescr"
                bindValue="hdID"
                formControlName="Region"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34"><a href="{{RouteGMBranch}}" target="_blank">Branch <span style="color:red;">*</span></a></div>
            <div class="col-sm-6">
              <ng-select
                [items]="BranchData"
                bindLabel="MainDescr"
                bindValue="hdID"
                formControlName="Branch"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Expense Category <span style="color:red;">*</span></div>
            <div class="col-sm-6">
              <ng-select
                [items]="ExpenseCategory"
                bindLabel="SubDescr"
                bindValue="SubID"
                formControlName="ExpenseCategory"
                (change)="onCategorySelect($event)"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34"><a href="{{RouteGMExpenseSubCategory}}" target="_blank">Expense Sub Category</a></div>
            <div class="col-sm-6">
              <ng-select
                [items]="ExpenseSubCategoryData"
                bindLabel="MainDescr"
                bindValue="hdID"
                formControlName="ExpenseSubCategory"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34"><a href="{{RouteGMNatureOfExpense}}" target="_blank">Nature of Expense<span style="color:red;">*</span></a></div>
            <div class="col-sm-6">
            <ng-select
                [items]="ExpenseNatureData"
                bindLabel="MainDescr"
                bindValue="hdID"
                placeholder="Not Selected"
                formControlName="NatureofExpense"
                (change)="onNatureofExpenseChange($event)"
            >
            </ng-select>
            </div>
    
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34" [hidden]="HideEmployee">Employee Name</div>
            <div class="col-sm-6" [hidden]="HideEmployee">
              <ng-select
                [items]="EmployeeData"
                bindLabel="name"
                bindValue="id1"
                formControlName="Employee"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-4 height-34" [hidden]="HideLawyer">Lawyer Name</div>
            <div class="col-sm-6" [hidden]="HideLawyer">
              <ng-select
                [items]="LawyerData"
                bindLabel="Name"
                bindValue="ContactID"
                formControlName="Lawyer"
                [clearable]="false"
                placeholder="Not Selected">
                <ng-option [value]="'0'">Not Selected</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-2" [hidden]="Hide">&nbsp;</div>
            <div class="col-sm-12" [hidden]="Hide">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Expense Date<span style="color:red;">*</span></div>
            <div class="col-sm-6">
                <mat-form-field class="fullwidth">
                    <input matInput  [min]="minDate" formControlName="ExpenseDate" [max]="maxDate" [matDatepicker]="pickerPlanupdate" placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="pickerPlanupdate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPlanupdate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Description<span style="color:red;">*</span></div>
            <div class="col-sm-6"><textarea class="form-control" formControlName="Description" rows="2" placeholder="Enter Description"></textarea></div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Total Amount</div>
            <div class="col-sm-6"><input type="number"  formControlName="UnitRate" [(ngModel)]="UnitRate4" class="form-control" placeholder="Enter Unit Rate" /></div>
            <div class="col-sm-2">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
    
    
    
            <div class="col-sm-4 height-34" [hidden]="HideCol">No. Of Unit</div>
            <div class="col-sm-6" [hidden]="HideCol"><input type="text" formControlName="NoofUnit" [(ngModel)]="NoofUnit4" class="form-control" placeholder="Enter Unit" /></div>
            <div class="col-sm-2" [hidden]="HideCol">&nbsp;</div>
            <div class="col-sm-12" [hidden]="HideCol">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34" [hidden]="HideCol">Total Amount</div>
            <div class="col-sm-6" style="padding-top: 10px;" [hidden]="HideCol"><label>&nbsp;&nbsp;{{UnitRate4*NoofUnit4}}</label></div>
            <div class="col-sm-2" [hidden]="HideCol">&nbsp;</div>
            <div class="col-sm-12" [hidden]="HideCol">
                <hr>
            </div>
    
    
    
    
    
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0" class="col-sm-4 height-34">Status</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0" class="col-sm-6">{{StatusType}}</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0" class="col-sm-2">&nbsp;</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0" class="col-sm-12">
                <hr>
            </div>
           
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0 && (this.Status=='1' || this.Status=='2')" class="col-sm-4 height-34">Reason For Reject or Approve</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0 && (this.Status=='1' || this.Status=='2')" class="col-sm-6">{{ReasonExpense}}</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0  && (this.Status=='1' || this.Status=='2')" class="col-sm-2">&nbsp;</div>
            <div *ngIf="this.IsDisplayButton=='0' && this.expenseID>0 && (this.Status=='1' || this.Status=='2')" class="col-sm-12">
                <hr>
            </div>
    
            <div *ngIf="this.IsDisplayButton=='1'" class="col-sm-4 height-34">Reason For Reject or Approve</div>
            <div *ngIf="this.IsDisplayButton=='1'" class="col-sm-6"><input type="text" formControlName="Reason" class="form-control" placeholder="Enter Reason For Reject or Accept" /></div>
            <div *ngIf="this.IsDisplayButton=='1'" class="col-sm-2">&nbsp;</div>
            <div *ngIf="this.IsDisplayButton=='1'" class="col-sm-12">
                <hr>
            </div>
    <div class="col-sm-4 height-34" >Upload File</div>
    <div class="col-sm-3" style="padding-top: 10px;">
        <input type='file' accept=".xlsx" (change)="onSelectFile($event)">
         <br/>
         <button *ngIf="this.expenseID>0" title="Upload File" class="btn  btn-primary btn-sm" type="submit" (click)="ExpenseFileUpload('')">
         Upload File&nbsp;<span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
     </button></div>
    <div class="col-sm-5"  *ngFor="let mDtl of FullyFileData">
       
            <br/> <br/> <br/>
            <button type="button" class="btn btn-success btn-sm btn-round waves-effect waves-light m-1" id="PREVIEWFILE" (click)="GETPREVIEWFILE()">{{mDtl.FullyFileName}}</button>
     
    
    </div>
    <div class="col-sm-12">
        <hr>
    </div>
    
            <div class="col-sm-12">&nbsp;</div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-6" [hidden]="HideButtonSubmit">
                <div class="form-group col-sm-12" *ngIf="this.RightsID.includes('202026001') || this.RightsID.includes('202026021') ; then AddExpenseLink else AddExpense"></div>
                <ng-template #AddExpenseLink>
                    <div *ngIf="this.IsDisplayButton=='0'">
                        <div class="col-sm-5">&nbsp;</div>
                        <input class="btn btn-primary col-sm-3" type="submit" value={{ButtonCaption}}>
                        <div class="col-sm-4"></div>
                    </div>
                    <div class="form-group col-sm-12"  *ngIf="this.IsDisplayButton=='1'">
                        <input class="btn btn-primary col-sm-3" type="submit" value={{ButtonCaption}}>
                        <div class="col-sm-1">&nbsp;</div>
                        <button type="button" style="display:none;" class="btn btn-primary col-sm-3" (click)="Approve(ExpenseFor.value); ">Approve</button>
    
                        <div class="col-sm-1">&nbsp;</div>
                        <button type="button" style="display:none;" class="btn btn-primary col-sm-3" (click)="Reject(ExpenseFor.value); ">Reject</button>
                        <div class="col-sm-1">&nbsp;</div>
                    </div>
                </ng-template>
                <ng-template #AddExpense>
                    &nbsp;
                </ng-template>
            </div>
    
            <div class="col-sm-2">&nbsp;</div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>
    
            </div>
            <div class="jumbotron p-4">
                <div class="container text-center col-sm-4 alertCssforPopup">
                    <app-alert></app-alert>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </form> -->
    }

</div>
